import React from 'react';
import { Layout, Button } from 'antd';
import styles from './css/Error.module.css'
import { Header, Footer, FormMessage } from './CorePageContents';
import * as CONSTANTS from '../../constants/constants';

const { Content } = Layout;

export const PartnerNotSetUserError = () => {

  // スキルマップマニュアルページに遷移
  const openManualClick = () => {
    window.open(CONSTANTS.URL_SMS_MANUAL);
  }

  return (
    <Layout>
      <Header />
      <Content>
        <div className={styles.mainMessage}>元請会社様へ利用設定のご依頼をお願いします</div>
        <br />
        <div className={styles.subMessage}>
          スキルマップサイトをご利用いただくには、<br />
          元請会社様にて「利用対象の協力会社」として設定いただく必要がございます。<br />
          現在、貴社が元請会社様から利用対象として設定されていないため、この画面が表示されています。
          <br />
          <br />
          大変お手数ですが、グリーンファイルの提出先である元請会社のご担当者様へご連絡いただき、<br />
          スキルマップサイトの利用設定をご依頼くださいますようお願いいたします。
          <br />
          <br />
          また、スキルマップサイトの操作マニュアルをご用意しています。<br />
          ご不明な点がありましたらマニュアルをご参照ください。
        </div>
        <br />
        <Button
          className={styles.sysButton}
          onClick={openManualClick}
        >
          マニュアルを見る
        </Button>
        <br />
        <FormMessage />
      </Content>
      <Footer />
    </Layout>
  );
}
